import clickAway from "../../common/clickAway.js";

export default (selector = ".js-language-selector") => {
  document.querySelectorAll(selector).forEach((elParent) => {
    const button = elParent.querySelector(".js-language-selector__button");
    let menuOpen = button.getAttribute("aria-expanded") === "true";

    if (!button) {
      return;
    }

    const closeMenu = (moveFocus) => {
      elParent.classList.remove("language-selector__navigation--open");
      button.setAttribute("aria-expanded", "false");
      menuOpen = false;

      if (moveFocus) {
        button.focus();
      }
    };

    const openMenu = () => {
      elParent.classList.add("language-selector__navigation--open");
      button.setAttribute("aria-expanded", "true");
      menuOpen = true;
    };

    button.addEventListener("click", () => {
      if (!menuOpen) {
        openMenu();
        clickAway(elParent, closeMenu);
      } else {
        closeMenu();
      }
    });
  });
};
